
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { PackageVersionSource } from '@/Sources';
  import { IPackageVersion } from '@/Interfaces';

  @Component({
    name: 'package-version-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class PackageVersionDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'PackageVersion' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop({ type: Boolean, default: false }) public inline!: boolean;
    @Prop({ type: Boolean, default: false }) public clearable!: boolean;
    @Prop() public placeholder!: string;
    @Prop() public packageId!: string;
    @Prop() public source!: PackageVersionSource | undefined | null;

    public packageVersionSource: PackageVersionSource | IPackageVersion[] = [];

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }

    public onDataLoad() {
      this.$emit('init');
    }
 

    @Watch('packageId', { immediate: true })
    public onPackageIdChanged(newPackageId: string | undefined) {
      if (this.source === undefined) {
        if (newPackageId) {
          this.packageVersionSource = new PackageVersionSource(newPackageId);
          this.$emit('loaded');
        } else {
          this.packageVersionSource = [];
        }
      }
    }

    @Watch('source', { immediate: true })
    public onSourceChanged(newSource: PackageVersionSource | undefined | null) {
      if (newSource !== undefined && newSource !== null) {
        this.packageVersionSource = newSource;
      } else {
        setTimeout(() => this.onPackageIdChanged(this.packageId));
      }
    }
  }
